import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent({
  strokeColor = "black",
  width = 18,
  height = 18,
  strokeWidth = 0.7,
  ...props
}) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <Path
        d="M11.627 9.01h0a.547.547 0 010 .76v-.76zm0 0L7.705 4.96h0a.52.52 0 00-.753.001h0a.549.549 0 00.001.76h0l3.554 3.67-3.554 3.67h0a.549.549 0 00-.001.758h0a.522.522 0 00.753.001h0l3.922-4.05v-.76z"
        fill={strokeColor}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
      />
    </Svg>
  );
}

export default SvgComponent;
